<template>
  <div class="container-fluid">
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <!-- {{packageConfigs}} -->
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <h3>
          {{
            form.invoiceType == "initial" ? `Send Invoice` : `Create Request`
          }}
        </h3>
        <hr />
        <el-form
          class="form"
          ref="form"
          :model="form"
          label-width="150px"
          label-position="left"
        >
          <el-form-item class="form-item" label="Type">
            <el-select
              style="width: 100%"
              v-model="form.invoiceType"
              @change="changeContact"
              id="customer-invoice"
              placeholder="--Customer Type--"
            >
              <el-option label="New" value="initial"></el-option>
              <el-option label="Existing" value="existing"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="form-item" label="Owner">
            <el-autocomplete
              style="width: 100%"
              id="customer-contact"
              class="inline-input"
              v-model="form.contact"
              :fetch-suggestions="contactSearch"
              placeholder="Search contact"
              prefix-icon="el-icon-search"
              @select="contactSelected"
            ></el-autocomplete>
          </el-form-item>

          <el-form-item class="form-item" label="Industry sector">
            <el-autocomplete
              style="width: 100%"
              id="sector-select"
              class="inline-input"
              v-model="form.sector"
              :fetch-suggestions="sectorSearch"
              placeholder="Select sector"
              prefix-icon="el-icon-suitcase"
              @select="sectorSelected"
            ></el-autocomplete>
          </el-form-item>

          <el-form-item class="form-item" label="Installation Name">
            <el-input
              style="width: 100%"
              id="customer-name"
              v-model="regDataParams.deviceRequest.installationName"
              :min="1"
            ></el-input>
          </el-form-item>

          <el-form-item class="form-item" label="Address">
            <el-input
              style="width: 100%"
              id="customer-address"
              v-model="regDataParams.deviceRequest.address"
              :min="1"
            ></el-input>
          </el-form-item>

          <el-form-item class="form-item" label="Package">
            <el-select
              style="width: 100%"
              v-model="form.package"
              placeholder="Package"
              @change="packageSelected"
            >
              <el-option
                v-for="(item, index) in systemTypes"
                :key="`${item.id}_package_${index}`"
                :label="item.name"
                :value="item.id"
                style="height: 55px"
              >
                <!-- style="height: 60px; line-height: 10px;" -->
                <h4 style="float: left; margin: 0px">{{ item.name }}</h4>
                <span
                  style="
                    float: left;
                    color: #8492a6;
                    font-size: 13px;
                    line-height: 20px;
                  "
                  >{{ item.description }}</span
                >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-item" label="System Capacity(KW)">
            <!-- <el-input placeholder="Please input" v-model="regDataParams.deviceRequest.systemCapacity"> -->
            <el-input-number
              v-model="regDataParams.deviceRequest.systemCapacity"
              controls-position="right"
              :min="5"
              style="width: 100%"
              :max="1000"
            ></el-input-number>

            <!-- </el-input> -->
          </el-form-item>
          <el-form-item class="form-item" label="Payment Model">
            <el-radio-group v-model="regDataParams.deviceRequest.paymentModel">
              <el-radio :label="`OS`">OS</el-radio>
              <el-radio :label="`LO`">LO</el-radio>
              <el-radio :label="`ES`">ES</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- `OS` -->
          <el-form-item class="form-item" label>
            <div v-if="regDataParams.deviceRequest.paymentModel == `OS`">
              <el-form-item class="form-item" label="Base price(₦)">
                <el-input-number
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.amount"
                  :min="1"
                ></el-input-number>
              </el-form-item>
            </div>
            <div v-if="regDataParams.deviceRequest.paymentModel == `LO`">
              <el-form-item class="form-item" label="Setup Fee (₦)">
                <el-input-number
                  :disabled="false"
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.setupFee"
                  :min="1"
                ></el-input-number>
              </el-form-item>

              <el-form-item class="form-item" label="Monthly Fee (₦)">
                <el-input-number
                  :disabled="false"
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.monthlyFee"
                  :min="1"
                ></el-input-number>
              </el-form-item>

              <el-form-item class="form-item" label="Caution Fee (₦)">
                <el-input-number
                  :disabled="false"
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.cautionFee"
                  :min="1"
                ></el-input-number>
              </el-form-item>

              <!-- <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <div>
                    VAT (%)
                    <el-select
                      v-model="regDataParams.deviceRequest.priceModel.orderVat"
                      placeholder="Select"
                      style="width: 100px"
                    >
                      <el-option
                        v-for="item in 101"
                        :key="`${item}_item_vat_list`"
                        :label="item -1"
                        :value="item -1"
                      ></el-option>
                    </el-select>
              </div>-->
              <!-- <div> -->
              <!-- <b-list-group-item class="d-flex justify-content-between align-items-center"> -->
              <!-- Discount (%)
                    <el-select
                      v-model="regDataParams.deviceRequest.priceModel.orderDiscount"
                      placeholder="Select"
                      style="width: 100px"
                    >
                      <el-option
                        v-for="item in 101"
                        :key="`${item}_item_list`"
                        :label="item -1"
                        :value="item -1"
                      ></el-option>
              </el-select>-->
              <!-- </b-list-group-item> -->
              <!-- </div> -->
              <!-- </b-list-group-item>
              </b-list-group>-->
            </div>
            <div v-if="regDataParams.deviceRequest.paymentModel == `ES`">
              <el-form-item class="form-item" label="Setup Fee (₦)">
                <el-input-number
                  :disabled="false"
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.setupFee"
                  :min="1"
                ></el-input-number>
              </el-form-item>

              <el-form-item class="form-item" label="Monthly Fee (₦)">
                <el-input-number
                  :disabled="false"
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.monthlyFee"
                  :min="1"
                ></el-input-number>
              </el-form-item>

              <el-form-item class="form-item" label="Caution Fee (₦)">
                <el-input-number
                  :disabled="false"
                  style="width: 100%"
                  id="customer-price"
                  v-model="regDataParams.deviceRequest.priceModel.cautionFee"
                  :min="1"
                ></el-input-number>
              </el-form-item>
              <!-- <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Setup Fee (₦)
                  <span class="price-display">{{ calcSetup(paymentModel) }}</span>
                </b-list-group-item>
              </b-list-group>

              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Monthly Subscription (₦)
                  <span class="price-display">{{ calcSub(paymentModel) }}</span>
                </b-list-group-item>
              </b-list-group>-->

              <!-- <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <div>
                    VAT (%)
                    <el-select
                      v-model="regDataParams.deviceRequest.priceModel.orderVat"
                      placeholder="Select"
                      style="width: 100px"
                    >
                      <el-option
                        v-for="item in 101"
                        :key="`${item}_item_vat_list`"
                        :label="item -1"
                        :value="item -1"
                      ></el-option>
                    </el-select>
                  </div>
                  <div> 
                    Discount (%)
                    <el-select
                      v-model="regDataParams.deviceRequest.priceModel.orderDiscount"
                      placeholder="Select"
                      style="width: 100px"
                    >
                      <el-option
                        v-for="item in 101"
                        :key="`${item}_item_list`"
                        :label="item -1"
                        :value="item -1"
                      ></el-option>
                    </el-select> 
                  </div>
                </b-list-group-item>
              </b-list-group>-->
            </div>
          </el-form-item>
          <!-- <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
          VAT (%)-->
          <!-- <el-form-item class="form-item" label=" VAT (%)">
            <el-select
              v-model="regDataParams.deviceRequest.orderVat"
              placeholder="Select"
              style="width: 100px"
            >
              <el-option
                v-for="item in 101"
                :key="`${item}_item_vat_list`"
                :label="item -1"
                :value="item -1"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <!-- </b-list-group-item>
          </b-list-group>-->

          <!-- <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
          Discount (%)-->
          <el-form-item class="form-item" label="Discount">
            <el-select
              v-model="discountType"
              placeholder="Discount type"
              style="width: 140px"
            >
              <el-option
                :key="`discount_item_list_percent`"
                label="Percent (%)"
                value="percent"
              ></el-option>
              <el-option
                :key="`discount_item_list_cash`"
                label="Amount (₦)"
                value="amount"
              ></el-option>
            </el-select>

            <el-select
              v-if="discountType == `percent`"
              v-model="regDataParams.deviceRequest.orderDiscount"
              placeholder="Select"
              style="width: 100px"
            >
              <el-option
                v-for="item in 101"
                :key="`${item}_item_list`"
                :label="item - 1"
                :value="item - 1"
              ></el-option>
            </el-select>
            <el-input-number
              v-else
              style="width: 180px"
              id="customer-price"
              v-model="regDataParams.deviceRequest.amountDiscount"
              :min="1"
            ></el-input-number>
          </el-form-item>
          <!-- </b-list-group-item>
          </b-list-group>-->
          <el-form-item class="fo​​rm-item" label="Description">
            <el-input
              type="textarea"
              :autosize="{ minRows: 8, maxRows: 12 }"
              placeholder="Please input"
              v-model="regDataParams.deviceRequest.comment"
            ></el-input>
            <!-- <el-input type="texta​​rea"  autosize :rows="3" id="customer-description" v-model="form.desc"></el-input> -->
          </el-form-item>
          <el-form-item class="fo​​rm-item" label="Terms">
            <el-input
              type="textarea"
              :autosize="{ minRows: 8, maxRows: 12 }"
              placeholder="Please input"
              v-model="regDataParams.deviceRequest.term"
            ></el-input>
            <!-- <el-input type="texta​​rea"  autosize :rows="3" id="customer-description" v-model="form.desc"></el-input> -->
          </el-form-item>
          <div class="form-group col-md-12">
            <label for="p-signup-email">Send Invoice</label>
            <el-switch
              style="width: 100%"
              v-model="regDataParams.deviceRequest.sendMail"
              active-text="Send Invoice"
              inactive-text="Don't send Invoice"
            ></el-switch>
          </div>
          <el-form-item>
            <el-button type="prim​​ary" class="customer-btn" @click="onSubmit()"
              >Create</el-button
            >
          </el-form-item>
        </el-form>
        <!-- {{systemTypes}} -->
      </div>
    </vk-offcanvas>
    <!-- <div class="page-content__header-description">Device Managements</div> -->
    <div class="col-xl-12 col-lg-12 col-md-12">
      <!-- {{activeTab}} -->
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px"
      >
        <h2 style="flex: 1">
          {{
            $can("create", "installation")
              ? `Customer Payment`
              : `Devices`
          }}
        </h2>
        <!-- <can I="create" a="installation">
          <span style="display: flex; align-items: center;">
            <button class="btn btn-primary" @click="showOffCanvas = true">New Request</button>
          </span>
        </can>-->
        <!-- <a class="btn btn-primary" :href="productReg+`${getRegUri(getUserSession.id)}`">
          Create Request &nbsp;
          <span class="fa fa-plus"></span>
        </a>-->
      </div>

       
      <!-- {{zohoModules}} -->
      <div class="col-xl-12 col-lg-12 col-md-12" >
        <div class="container-fluid">
          <el-tabs v-model="activeTab" >
            
            <can I="create" a="inventory">
              <el-tab-pane label="Payment Schedule" name="payment_schedule" >
              <PaymentShedule />
              </el-tab-pane>
            </can>
          
            <can I="create" a="installation">
              <el-tab-pane
                label="Due Payment"
                name="due_payment"
              >
                <Payment></Payment>
              </el-tab-pane>
            </can>
              <can I="create" a="inventory">
              <el-tab-pane label="Transaction History" name="transaction" >
              <Transaction />
              </el-tab-pane>
            </can>
           
          </el-tabs>
        </div>
      </div>

    

      

    </div>
  </div>
</template>

<script>
import DeviceRequest from "../devices/MyRequests";
import ManageRequestsuser from "../devices/ManageRequestsuser";
import Notification from '../devices/Notification';
import Users from "../user-mgt/Users";
import CustomerGroup from "../user-mgt/CustomerGroup";
import MyDeviceList from "../devices/List";
import ApprovedInstallations from "../instalation/instalationList";
import inventoryRequest from "../instalation/inventoryRequest";
import OngoingInstallations from "../instalation/ongoingInstalation";
import RightBar from "../rightBar";
import Payment from '../payment/due_payments'
import PaymentShedule from '../payment/payment_schedule'
import Transaction from '../payment/transaction_history'

import { mapGetters, mapActions } from "vuex";
// import { ZOHOTHTTP } from "../../../store/actions";
import axios from "axios";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton,
} from "element-ui";
import sectorList from "@/mockData/sectors.json";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";

var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function (e) {
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = ((n & 3) << 4) | (r >> 4);
      u = ((r & 15) << 2) | (i >> 6);
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t =
        t +
        this._keyStr.charAt(s) +
        this._keyStr.charAt(o) +
        this._keyStr.chmanage;
      this._keyStr.chmanage;
    }
    return t;
  },
  decode: function (e) {
    manage;
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9+/=]/g, "");
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = (s << 2) | (o >> 4);
      r = ((o & 15) << 4) | (u >> 2);
      i = ((u & 3) << 6) | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = Base64._utf8_decode(t);
    return t;
  },
  _utf8_encode: function (e) {
    e = e.replace(/rn/g, "n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode((r >> 6) | 192);
        t += String.fromCharCode((r & 63) | 128);
      } else {
        t += String.fromCharCode((r >> 12) | 224);
        t += String.fromCharCode(((r >> 6) & 63) | 128);
        t += String.fromCharCode((r & 63) | 128);
      }
    }
    return t;
  },
  _utf8_decode: function (e) {
    var t = "";
    var n = 0;
    var r = (c1 = c2 = 0);
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode(
          ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );
        n += 3;
      }
    }
    return t;
  },
};

export default {
  name: "",
  props: ["_activeTab"],
  data() {
    return {
      discountType: "percent",
      usertype: localStorage.roleType,
      ZcontactList: [],
      selectedPaymentModel: [],
      packageConfigs: [],
      // paymentModel: `OS`,
      // setupFee: "",
      // monthlyFee: "",
      // cautionFee: "",
      regDataParams: {
        firstName: null,
        roleType: "customer",
        lastName: null,
        dateOfBirth: new Date(),
        gender: 0,
        phoneNumber: null,
        realm: "",
        username: "",
        email: null,
        def: true,
        street_route: null,
        password: "<%DUMMY%>",
        cpassword: "<%DUMMY%>",
        stateId: null,
        countryId: 1,
        lgaId: null,
        deviceRequest: {
          sector: "",
          installationName: "",
          paymentModel: "OS",
          priceModel: {
            amount: "",
            setupFee: "",
            monthlyFee: "",
            cautionFee: "",
          },
          systemCapacity: 5,
          orderVat: 5,
          orderDiscount: 0,
          typeOfBuilding: "Normal",
          roofType: "Aluminium",
          roofCondition: "Very Good",
          roofReadiness: "Very Ready",
          roofAge: 4,
          roofComment: "No comment here	Roof is ready for installation",
          deviceTypeId: null,
          comment: null,
          sendMail: true,
        },
      },
      zohoToken: {},
      zohoModules: [],
      systemTypes: [],
      contactList: [],
      form: {
        userId: null,
        package: null,
        sector: "",
        contact: "",
        invoiceType: "initial",
        paymentModel: {
          name: "",
          setupFee: "",
          monthlyFee: "",
          cautionFee: "",
          orderDiscount: "",
          orderVat: "",
        },
        desc: "",
      },
      productReg: "https://arnergy.surge.sh/products.html?q=",
      activeTab: this.$route.params.activetab,
      showOffCanvas: false,
    };
  },
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    DeviceRequest,
    ManageRequestsuser,
    Payment,
    ApprovedInstallations,
    OngoingInstallations,
    PaymentShedule,
    Transaction,
    inventoryRequest,
    MyDeviceList,
    RightBar,
    Notification,
    Users,
    CustomerGroup
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  computed: {
    ...mapGetters(["getUserSession"]),
    paymentModel() {
      return this.regDataParams.deviceRequest.paymentModel;
    },
  },
  watch: {
    paymentModel: function (newVal, oldVal) {
      this.selectedPaymentModel = this.packageConfigs.find(
        (x) => x.Package == newVal
      );
      this.regDataParams.deviceRequest.paymentModel = newVal;
      // console.log(newVal.price);
      this.regDataParams.deviceRequest.priceModel.amount = this.form.price;
      if (this.selectedPaymentModel) {
        this.regDataParams.deviceRequest.priceModel.setupFee = this.calcSetup(
          this.form.price
        );
        this.regDataParams.deviceRequest.priceModel.monthlyFee = this.calcSub(
          this.form.price
        );
        this.regDataParams.deviceRequest.priceModel.cautionFee = this.calcCaution(
          this.form.price
        );
      }
    },
  },
  methods: {
    changeContact() {
      this.form.invoiceType == "initial"
        ? (this.contactList = this.ZcontactList)
        : (this.contactList = this.customerList);
      //console.log(this.customerList)
    },
    calcSetup(price) {
      let setupPercent = Number(this.selectedPaymentModel["Setup"]) / 100;
      // console.log( this.form.price);
      let temp_price = Number(setupPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcSub(price) {
      let subscriptionPercent =
        Number(this.selectedPaymentModel["Subscription"]) / 100;
      let temp_price = Number(subscriptionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcCaution(price) {
      let cautionPercent = Number(this.selectedPaymentModel["Caution"]) / 100;
      let temp_price = Number(cautionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    async onSubmit() {
      if (this.form.package == null) {
        this.showErrorMsg({
          message: "Please select a device type",
        });
      } else if (this.form.sector == null) {
        this.showErrorMsg({
          message: "Please select an sector",
        });
      } else {
        this.regDataParams.deviceRequest.deviceTypeId = this.form.package;
        // this.regDataParams.deviceRequest.orderDiscount = this.orderDiscount;
        // this.regDataParams.deviceRequest.orderVat = this.orderVat;
        let regDataParams = this.regDataParams;
        // let orderDiscount = this.orderDiscount;
        // let orderVat = this.orderVat;
        //console.log(this.contactList);
        //console.log(this.form);
        const HTTP = this.$httpUtils.instance;
        console.log(JSON.stringify(regDataParams));
        try {
          let resp =
            this.form.invoiceType == "initial"
              ? await HTTP.post("/users", regDataParams)
              : await HTTP.post("/device_requests", {
                  ...regDataParams.deviceRequest,
                  // status: 1,
                  priceModel: regDataParams.deviceRequest.priceModel,
                  status: this.regDataParams.deviceRequest.sendMail ? 0 : 1,
                  userId: this.form.userId,
                });
          this.showSuccessMsg({ message: "Request Submitted" });
          //   // this.activeTab="manage_requests";
          //   // this.renderManageComponent= true;
          this.showOffCanvas = false;
          this.$router.push({
            name: "devices",
            params: {
              activetab: "manage_requests",
            },
          });
          //   this.$router.go();
        } catch (error) {
          if (error.response) {
            if (error.response.data) {
              // console.log(error.response.data);
              let error_incomming = error.response.data.error.details.messages;
              // console.log(error_incomming);
              let tempMsg = Object.keys(error_incomming).map(
                (x) => `${x}: ${error_incomming[x].join(",")}`
              );
              this.showErrorMsg({
                message: tempMsg.join("<br>"),
              });
            }
          }
          console.log({
            error,
          });
        }

        // this.showOffCanvas=false;
        // this.$router.push({
        //   name: "devices",
        //   params: {
        //     activetab: "manage_requests"
        //   }
        // });
        // this.$router.go()

        // .then(resp => {
        //   console.log(resp);
        // })
        // .catch(function(error_incomming) {
        //   console.log(error_incomming);
        // let tempMsg = Object.keys(error_incomming["messages"]).map(
        //   x => `${x}: ${error_incomming[x].join(",")}`
        // );
        // this.showWarnMsg({
        //   message: tempMsg.join("<br>")
        // });
        // });
      }
    },
    packageSelected() {
      this.regDataParams.deviceRequest.deviceTypeId = this.form.package;
      this.form.price = this.systemTypes.find((x) => x.id == this.form.package)[
        "price"
      ];
      this.regDataParams.deviceRequest.priceModel.amount = this.form.price;
      this.regDataParams.deviceRequest.priceModel.setupFee = this.calcSetup(
        this.form.price
      );
      this.regDataParams.deviceRequest.priceModel.monthlyFee = this.calcSub(
        this.form.price
      );
      // console.log({
      //   form: this.calcSetup(this.form.price)
      // });
    },
    contactSelected(contact) {
      this.regDataParams = {
        ...this.regDataParams,
        firstName: contact["First_Name"],
        lastName: contact["Last_Name"],
        phoneNumber: contact["Phone"],
        username: contact["Email"],
        email: contact["Email"],
      };
      this.regDataParams.deviceRequest.installationName = `${contact["First_Name"]} ${contact["Last_Name"]}`;
      if (this.form.invoiceType == "existing") {
        this.form.userId = contact["id"];
      }
    },
    sectorSelected(sector) {
      this.regDataParams.deviceRequest.sector = `${sector["name"]}`;
    },
    getRegUri(data) {
      return Base64.encode(`�6` + data);
    },
    loadAll(page = 1) {
      // console.log("++++++++++++++++++++++++++");
      // console.log(page);
      //  console.log(this.form)
      const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      let container = this;
      let collection = "Contacts?fields=Email,First_Name,Last_Name,Phone";
      if (page > 1) {
        collection =
          "Contacts?fields=Email,First_Name,Last_Name,Phone&page=" + page;
      }
      ZOHOTHTTP.get(`fetchAll`, {
        params: {
          collection,
        },
      })
        .then((response) => response.data["result"])
        .then((resultData) => {
          let tempList = resultData["data"];
          // console.log(tempList);
          container.ZcontactList = [
            ...container.ZcontactList,
            ...tempList.map((x) => ({
              ...x,
              value: x.First_Name
                ? `${x.First_Name} ${x.Last_Name}`
                : x.Last_Name,
            })),
          ];
          container.contactList = container.ZcontactList;
          // console.log(container.ZcontactList);
          if (resultData["info"]["more_records"] == true) {
            this.loadAll(resultData["info"]["page"] + 1);
          }
        })
        .catch((e) => {
          console.log("========Err=========");
          console.log(e);
          // this.refreshZohoToken();
        });
    },
    fetchUsers() {
      const HTTP = this.$httpUtils.instance;
      let container = this;
      //  filter={"include": ["installations"]}
      const url = `/users?filter[where][roleType]=customer`+`&filter[order]=id DESC`;
      HTTP.get(url)
        .then((response) => {
          container.customerList = response.data.map((x) => ({
            ...x,
            First_Name: x.firstName,
            Last_Name: x.lastName,
            value: `${x.firstName} ${x.lastName}`,
          }));
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    loadModules() {
      console.log("++++++++++++++++++++++++++");
      // console.log(this.zohoToken);
      const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      let container = this;
      ZOHOTHTTP.get(`/settings/all`, {
        headers: {
          Authorization: `Zoho-oauthtoken ${this.zohoToken["accessToken"]}`,
          "Content-Type": " application/json;charset=UTF-8",
        },
      })
        .then((response) => {
          container.zohoModules = response.data["data"];
        })
        .catch((e) => {
          console.log("========Err=========");
          console.log(e);
          // this.refreshZohoToken();
        });
    },
    createFilter(queryString, contact) {
      return (
        `${contact.First_Name} ${contact.Last_Name}`
          .toLowerCase()
          .indexOf(queryString.toLowerCase()) > -1
      );
    },
    contactSearch(queryString, cb) {
      let contacts = this.contactList;
      var results = queryString
        ? contacts.filter((contact) => this.createFilter(queryString, contact))
        : contacts;
      // console.log({ results });
      cb(results);
    },
    createSectorFilter(queryString, sector) {
      console.log({ sector });
      return (
        `${sector.value.trim()}`
          .toLowerCase()
          .indexOf(queryString.toLowerCase()) > -1
      );
    },
    sectorSearch(queryString, cb) {
      //  sectorList;
      // console.log({sectorList});
      var results = queryString
        ? sectorList.filter((sect) =>
            this.createSectorFilter(queryString.trim(), sect)
          )
        : sectorList;
      // console.log({ results });
      cb(results);
    },
    // async fetchZohoToken() {
    //   const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
    //   return await ZOHOTHTTP.get("get-zoho-token");
    // },
    async fetchPackageConfig() {
      const HTTP = this.$httpUtils.instance;
      return await HTTP.get("/package-configs");
    },
    async refreshZohoToken() {
      const HTTP = this.$httpUtils.instance;
      let newToken = await HTTP.post("/zohos/refresh-zoho-token");
      this.zohoToken = newToken.data.token;
      this.showErrorMsg({
        message: "Token refreshed, Please reload page",
      });
      // this.loadAll();
    },
    fetchSysTypes() {
      const HTTP = this.$httpUtils.instance;
      const url =
        "/device_types?filter[include][packageComponents]=componentType";
      return HTTP.get(url)
        .then((response) => {
          this.systemTypes = response.data;
          // console.log({ systemTypes });
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
  async mounted() {
    if (this._activeTab) {
      this.activeTab = this._activeTab;
    }
    // let _tmpdata = await this.fetchZohoToken();
    let tmpPackageConfig = await this.fetchPackageConfig();
    this.packageConfigs = tmpPackageConfig["data"];
    this.regDataParams.deviceRequest = {
      ...this.regDataParams.deviceRequest,
      salesManager: `${this.getUserSession.firstName} ${this.getUserSession.lastName}`,
      salesManagerContact: `${this.getUserSession.phoneNumber}`,
    };
    // console.log(this.zohoToken.data.token);
    // this.zohoToken = _tmpdata.data.token;
    // this.loadAll();
    this.fetchUsers();
    this.fetchSysTypes();
    // console.log(this._activeTab);

    // axios.interceptors.response.use(
    //   function(response) {
    //     return response;
    //   },
    //   function(error) {
    //     console.log(error);
    //     // handle error
    //     if (error.response) {
    //       alert(error.response.data.message);
    //     }
    //   }
    // );
    // const HTTP = this.$httpUtils.instance;

    // this.loadModules();
  },
};
</script>

<style lang="scss" scoped>
.container-fluid .page-content {
  padding: 0px !important;
}

.container-fluid .container-fluid {
  padding: 0px !important;
}
.el-form-item__label {
  text-align: left !important;
}
.el-select-dropdown__item {
  line-height: 20px;
  display: flex;
  flex-flow: column;

  span {
    line-height: 20px !important;
  }
}
.price-display {
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/submodules/payment.vue